import {
  FETCH_SUMMARY_PAGE_FIELDS,
  SET_BUY_URL,
  TOGGLE_EMAIL_MODAL,
  SET_SENDING_EMAIL_TEXT,
  TOGGLE_EMAIL_SENT,
} from "./types";
import ContentfulApi from "../../lib/ContentfulApi";
import { functions } from "../../firebase";
import queryString from "query-string";
import mergeImages from "merge-images";

export const fetchSummaryPageFields = () => {
  return (dispatch) => {
    const api = new ContentfulApi();

    api
      .getSummaryPageFields()
      .then((response) => {
        dispatch({
          type: FETCH_SUMMARY_PAGE_FIELDS,
          payload: response,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
};

export const sendEmail = (history, to, sender, message) => {
  return (dispatch, getState) => {
    if (
      !getState().ring.activeMainRing &&
      !getState().ring.activeHolderRings &&
      !history &&
      !to &&
      !sender &&
      !message &&
      !getState().summaryPage.buyURL
    ) {
      // Can't send email
    } else {
      const queryParams = history
        ? queryString.parse(history.location.search)
        : null;
      const mainRingMaterial = queryParams
        ? queryParams["ring-material"]
        : null;
      const holderRingsMaterial = queryParams
        ? queryParams["holder-material"]
        : null;
      const ringInfos = mapRingInfos(
        getState().ring.activeMainRing,
        mainRingMaterial,
        getState().ring.activeHolderRings,
        holderRingsMaterial
      );
      if (ringInfos) {
        createSingleImage(
          ringInfos.mainRingImageURL,
          ringInfos.diamondImageURL,
          ringInfos.holderRingHighImageURL,
          ringInfos.holderRingLowImageURL,
          ringInfos.shadowImageURL
        )
          .then((data) => {
            const sendGridEmail = createSendGridEmail(
              data,
              ringInfos.mainRingPrice,
              ringInfos.holderRingPrice,
              ringInfos.mainRingTitle,
              ringInfos.holderRingsTitle,
              to,
              sender,
              message,
              getState().summaryPage.buyURL,
              queryParams
            );
            dispatch({
              type: SET_SENDING_EMAIL_TEXT,
              payload: "Lähetetään sähköpostia...",
            });
            const callable = functions.httpsCallable("ojlEmail");
            return callable(sendGridEmail)
              .then((response) => {
                if (response.data.success) {
                  dispatch({
                    type: TOGGLE_EMAIL_MODAL,
                  });
                  dispatch({
                    type: SET_SENDING_EMAIL_TEXT,
                    payload: "",
                  });
                  dispatch(toggleEmailSentModal());
                } else {
                  dispatch({
                    type: SET_SENDING_EMAIL_TEXT,
                    payload:
                      "Sähköpostin lähetyksessä tapahtui virhe. Yritä uudestaan.",
                  });
                }
              })
              .catch((error) => console.log(error));
          })
          .catch((error) => console.log(error));
      }
    }
  };
};

export const sendEmailNecklace = (queryParams, to, sender, message) => {
  return (dispatch, getState) => {
    const necklace = getState().necklace
      ? getState().necklace.activeNecklace
      : null;
    const memories = getState().necklace
      ? getState().necklace.activeMemories
      : null;
    // TODO: Create email and and send it.
    console.log(queryParams, to, sender, message, necklace, memories);
  };
};

export const setBuyURL = (url) => {
  return (dispatch) => {
    if (url) {
      dispatch({
        type: SET_BUY_URL,
        payload: url,
      });
    }
  };
};

const mapRingInfos = (
  mainRing,
  mainRingMaterial = "yellow-gold",
  holderRings,
  holderRingsMaterial = "yellow-gold"
) => {
  if (mainRing && holderRings) {
    const ringInfos = {
      mainRingImageURL: "",
      mainRingPrice: 0,
      mainRingTitle: "",
      holderRingHighImageURL: "",
      holderRingLowImageURL: "",
      holderRingPrice: 0,
      holderRingsTitle: "",
      diamondImageURL: "",
      shadowImageURL: "",
    };
    ringInfos.mainRingTitle = mainRing.fields.title;
    ringInfos.holderRingsTitle = `2 kpl ${holderRings.fields.title}`;
    switch (mainRingMaterial) {
      case "yellow-gold":
        ringInfos.mainRingImageURL = mainRing.fields.imageYellowGoldURL;
        ringInfos.diamondImageURL = mainRing.fields.imageYellowGoldDiamondURL;
        ringInfos.mainRingPrice = mainRing.fields.priceYellowGold;
        break;
      case "rose-gold":
        ringInfos.mainRingImageURL = mainRing.fields.imageRoseGoldURL;
        ringInfos.diamondImageURL = mainRing.fields.imageRoseGoldDiamondURL;
        ringInfos.mainRingPrice = mainRing.fields.priceRoseGold;
        break;
      case "white-gold":
        ringInfos.mainRingImageURL = mainRing.fields.imageWhiteGoldURL;
        ringInfos.diamondImageURL = mainRing.fields.imageWhiteGoldDiamondURL;
        ringInfos.mainRingPrice = mainRing.fields.priceWhiteGold;
        break;
      case "platinum":
        ringInfos.mainRingImageURL = mainRing.fields.imagePlatinumURL;
        ringInfos.diamondImageURL = mainRing.fields.imagePlatinumDiamondURL;
        ringInfos.mainRingPrice = mainRing.fields.pricePlatinum;
        break;
      default:
        break;
    }
    switch (holderRingsMaterial) {
      case "yellow-gold":
        ringInfos.holderRingHighImageURL =
          holderRings.fields.imageYellowGoldUpperURL;
        ringInfos.holderRingLowImageURL =
          holderRings.fields.imageYellowGoldLowerURL;
        ringInfos.shadowImageURL = holderRings.fields.imageYellowGoldShadowURL;
        ringInfos.holderRingPrice = holderRings.fields.priceYellowGold * 2;
        break;
      case "rose-gold":
        ringInfos.holderRingHighImageURL =
          holderRings.fields.imageRoseGoldUpperURL;
        ringInfos.holderRingLowImageURL =
          holderRings.fields.imageRoseGoldLowerURL;
        ringInfos.shadowImageURL = holderRings.fields.imageRoseGoldShadowURL;
        ringInfos.holderRingPrice = holderRings.fields.priceRoseGold * 2;
        break;
      case "white-gold":
        ringInfos.holderRingHighImageURL =
          holderRings.fields.imageWhiteGoldUpperURL;
        ringInfos.holderRingLowImageURL =
          holderRings.fields.imageWhiteGoldLowerURL;
        ringInfos.shadowImageURL = holderRings.fields.imageWhiteGoldShadowURL;
        ringInfos.holderRingPrice = holderRings.fields.priceWhiteGold * 2;
        break;
      case "platinum":
        ringInfos.holderRingHighImageURL =
          holderRings.fields.imagePlatinumUpperURL;
        ringInfos.holderRingLowImageURL =
          holderRings.fields.imagePlatinumLowerURL;
        ringInfos.shadowImageURL = holderRings.fields.imagePlatinumShadowURL;
        ringInfos.holderRingPrice = holderRings.fields.pricePlatinum * 2;
        break;
      default:
        break;
    }
    return ringInfos;
  }

  return null;
};

export const toggleEmailModal = () => {
  return (dispatch) => {
    dispatch({
      type: TOGGLE_EMAIL_MODAL,
    });
  };
};

export const toggleEmailSentModal = () => {
  return (dispatch) => {
    dispatch({
      type: TOGGLE_EMAIL_SENT,
    });
  };
};

const createSendGridEmail = (
  data,
  mainRingPrice = 0,
  holderRingPrice = 0,
  mainRingTitle = "",
  holderRingsTitle = "",
  to,
  sender,
  message,
  buyURL,
  queryParams
) => {
  if (data) {
    const totalPrice = mainRingPrice + holderRingPrice;
    const currentURL = `https://ojl.fi/pages/digital-showroom/?${queryString.stringify(
      queryParams
    )}`;
    const emailData = {
      to: to,
      sender: sender,
      from: { email: "digital.showroom@ojl.fi", name: "OJL Digital Showroom" },
      message: message,
      title_text: "Sinun tarinasi",
      price_text: "Hinta",
      ring_src: data,
      total_price: totalPrice,
      buy_button_url: buyURL,
      buy_button_text: "Osta",
      showroom_button_url: currentURL,
      showroom_button_text: "Showroomiin",
      selected_rings_title_text: "Valitut mallistot",
      selected_main_ring: mainRingTitle,
      selected_main_ring_price: mainRingPrice,
      selected_holder_rings: holderRingsTitle,
      selected_holder_rings_price: holderRingPrice,
    };

    return emailData;
  }

  return null;
};

const createSingleImage = async (
  ringImageURL,
  diamondImageURL,
  holderImageUpperURL,
  holderImageLowerURL,
  shadowImageURL
) => {
  try {
    if (
      ringImageURL &&
      diamondImageURL &&
      holderImageUpperURL &&
      holderImageLowerURL &&
      shadowImageURL
    ) {
      const images = await mergeImages(
        [
          { src: holderImageUpperURL, x: 0, y: 0 },
          { src: ringImageURL, x: 0, y: 0 },
          { src: holderImageLowerURL, x: 0, y: 0 },
          { src: diamondImageURL, x: 0, y: 0 },
          { src: shadowImageURL, x: 0, y: 0, opacity: 0.3 },
        ],
        { crossOrigin: "Anonymous" }
      );
      if (images) {
        return images;
      }
    }
  } catch (error) {
    return error;
  }
};
